'use client'

import { ToastContainer } from 'react-toastify'
import { useLayoutContext } from '@/context/useLayoutContext'

export default function ThemeAwareToastContainer() {
  const { theme } = useLayoutContext()

  return <ToastContainer theme={theme === 'dark' ? 'dark' : 'colored'} />
}
